import crc from 'crc';

export const generatePixQRCode = ({ amount, pixKey, pixKeyType, name, city, observation }) => {
  // Função para formatar os campos do QR Code Pix
  const formatField = (id, value) => {
    const length = value.length.toString().padStart(2, '0');
    return `${id}${length}${value}`;
  };

  const clearText = (text) => {
    if (!text) return;
    return text.replace(/[^a-zA-Z0-9]/g, '');
  }

  // Campos fixos do QR Code Pix
  const payloadFormatIndicator = formatField('00', '01'); // Indica o formato do payload
  const merchantAccountInformation = formatField(
    '26',
    formatField('00', 'BR.GOV.BCB.PIX') + // Domínio do Pix
    formatField('01', clearText(pixKey)) // Chave Pix
  );
  const merchantCategoryCode = formatField('52', '0000'); // Categoria do comerciante
  const transactionCurrency = formatField('53', '986'); // Moeda (BRL)
  const transactionAmount = formatField('54', amount.toFixed(2)); // Valor da transação
  const countryCode = formatField('58', 'BR'); // Código do país
  const merchantName = formatField('59', clearText(name)); // Nome do recebedor
  const merchantCity = formatField('60', clearText(city)); // Cidade do recebedor
  const additionalDataFieldTemplate = formatField(
    '62',
    formatField('05', clearText(observation) || '***') // Finalidade do pagamento
  );

  // Monta o payload completo (sem o CRC16)
  const payload = [
    payloadFormatIndicator,
    merchantAccountInformation,
    merchantCategoryCode,
    transactionCurrency,
    transactionAmount,
    countryCode,
    merchantName,
    merchantCity,
    additionalDataFieldTemplate,
    '6304' // Campo do CRC16 (placeholder)
  ].join('');

  // Calcula o CRC16 usando o módulo crc
  const crc16 = calculateCRC16(payload);

  // Retorna o payload completo com o CRC16
  return payload + crc16;
}

const calculateCRC16 = (payload) => {
  const polynom = 0x1021; // Polinômio
  let crc = 0xFFFF; // Valor inicial

  for (let i = 0; i < payload.length; i++) {
    crc ^= payload.charCodeAt(i) << 8; // XOR com o byte atual
    for (let j = 0; j < 8; j++) {
      if (crc & 0x8000) {
        crc = (crc << 1) ^ polynom;
      } else {
        crc <<= 1;
      }
    }
  }

  return (crc & 0xFFFF).toString(16).toUpperCase().padStart(4, '0'); // Retorna o CRC em hexadecimal
};